import { render, staticRenderFns } from "./pagePlanStudyDevelop.vue?vue&type=template&id=08cffc06&scoped=true"
import script from "./pagePlanStudyDevelop.vue?vue&type=script&lang=js"
export * from "./pagePlanStudyDevelop.vue?vue&type=script&lang=js"
import style0 from "./pagePlanStudyDevelop.vue?vue&type=style&index=0&id=08cffc06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cffc06",
  null
  
)

export default component.exports